import { getPrivacyClauseApi } from 'api/article'
import errorHandler from 'utils/errorHandler'

export default payload => async (dispatch) => {
  try {
    return await getPrivacyClauseApi(payload)
  } catch (error) {
    return errorHandler(error)
  }
}
